export const dialogSlotProps = {
  backdrop: {
    sx: {
      backdropFilter: 'blur(6px)',
      backgroundColor: 'rgba(15, 23, 42, 0.28)',
    },
  },
  paper: {
    sx: {
      borderRadius: 2,
    },
  },
};
